"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var react_switch_1 = tslib_1.__importDefault(require("react-switch"));

var colors_1 = require("../../styles/colors");

var color_1 = require("../../styles/utils/color");

var Switch = function Switch(_a) {
  var checked = _a.checked,
      baseColor = _a.baseColor,
      disabled = _a.disabled,
      handleColor = _a.handleColor,
      onChange = _a.onChange,
      size = _a.size;
  var isSmall = size && size === 'small';
  return react_1.default.createElement(react_switch_1.default, {
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    onColor: baseColor,
    onHandleColor: handleColor,
    offColor: colors_1.gray[300],
    offHandleColor: colors_1.white,
    handleDiameter: isSmall ? 16 : 20,
    height: isSmall ? 10 : 14,
    width: isSmall ? 26 : 34,
    checkedIcon: false,
    uncheckedIcon: false,
    boxShadow: "0 2px 2px " + color_1.getColorWithAlpha(colors_1.black, 0.24) + ",\n\t\t\t\t0 0 2px " + color_1.getColorWithAlpha(colors_1.black, 0.12),
    activeBoxShadow: "0 2px 2px " + color_1.getColorWithAlpha(colors_1.black, 0.24) + ",\n\t\t\t\t0 0 2px " + color_1.getColorWithAlpha(colors_1.black, 0.12)
  });
};

exports.default = Switch;